
/*
 * ! @chakra-ui/vue v0.11.0 by Jonathan Bakebwa @codebender828
 * MIT License
 * https://github.com/chakra-ui/chakra-ui-vue
 */

import { R as createStyledAttrsMixin } from './index-4e48fa90.js';
import './chakra-ui-styled-system.esm-b7ad2a27.js';
import '@emotion/css';
import 'vue';
import './color-mode-observer-14d12060.js';

/**
 * Hey! Welcome to @chakra-ui/vue PseudoBox
 *
 * The PseudoBox component
 *
 * @see Docs     https://vue.chakra-ui.com/pseudobox
 * @see Source   https://github.com/chakra-ui/chakra-ui-vue/blob/master/packages/chakra-ui-core/src/CPseudoBox/CPseudoBox.js
 */
/**
 * CPseudoBox component
 *
 * The pseudobox component that accepts pseudo props
 *
 * @extends CBox
 * @see Docs https://vue.chakra-ui.com/pseudobox
 */

var CPseudoBox = {
  name: 'CPseudoBox',
  mixins: [createStyledAttrsMixin('CPseudoBox')],
  props: {
    as: {
      type: [String, Object],
      default: function _default() {
        return 'div';
      }
    },
    to: [String, Object]
  },
  render: function render(h) {
    return h(this.as, {
      props: {
        to: this.to
      },
      class: this.className,
      on: this.listeners$,
      attrs: this.computedAttrs
    }, this.$slots.default);
  }
};

export default CPseudoBox;
